import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Formatter from './formatter'

//global
import globalCn from './cn/global';
import globalEn from './en/global';

//video
import videoCn from './cn/video';
import videoEn from './en/video'

//about
import aboutCn from './cn/about';
import aboutEn from './en/about'

//detail
import detailCn from './cn/detail';
import detailEn from './en/detail'

//header
import headerCn from './cn/header';
import headerEn from './en/header';

//user
import userCn from './cn/user';
import userEn from './en/user';

//search
import searchCn from './cn/search'
import searchEn from './en/search'

//business
import businessCn from './cn/business'
import businessEn from './en/business'

//project
import projectCn from './cn/project';
import projectEn from './en/project';

//works
import worksCn from './cn/works';
import worksEn from './en/works';

//live
import liveCn from './cn/live';
import liveEn from './en/live';

//collect
import collectCn from './cn/collect';
import collectEn from './en/collect';

//people
import peopleCn from './cn/people';
import peopleEn from './en/people';

//recruit
import recruitCn from './cn/recruit';
import recruitEn from './en/recruit';

Vue.use(VueI18n)


let lan = location.hash && location.hash.split('#!')[1];
let navLanguage = navigator.language||navigator.userLanguage;
if (lan) {
    if (lan !=='zh' && lan!=='en') {
        lan = 'zh';
        window.location.href = location.origin + '' + location.pathname + "#!zh";
    }
}
if (!lan && localStorage.getItem('language')) {
    lan = localStorage.getItem('language').split('#!')[1];
} else if (!lan) {
    if (navLanguage) {
        lan = navLanguage.substr(0, 2) == 'zh' ? 'zh':'en';
    } else {
        lan ='zh';
    }
}
const locale = lan; // default locale
const formatter = new Formatter({ locale })

export default new VueI18n({
    locale,
    formatter,
    messages: {
        'zh': {
            global: globalCn,
            video: videoCn,
            about: aboutCn,
            detail: detailCn,
            header: headerCn,
            user: userCn,
            search: searchCn,
            business: businessCn,
            project: projectCn,
            works: worksCn,
            live: liveCn,
            collect: collectCn,
            people: peopleCn,
            recruit: recruitCn
        },
        'en': {
            global: globalEn,
            video: videoEn,
            about: aboutEn,
            detail: detailEn,
            header: headerEn,
            user: userEn,
            search: searchEn,
            business: businessEn,
            project: projectEn,
            works: worksEn,
            live: liveEn,
            collect: collectEn,
            people: peopleEn,
            recruit: recruitEn
        }
    }
})



// WEBPACK FOOTER //
// ./src/languages/i18n.js